import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, forwardRef } from '@angular/core';
import {
	AbstractControl,
	ControlValueAccessor,
	FormControl,
	FormGroup,
	NG_VALIDATORS,
	NG_VALUE_ACCESSOR,
	ReactiveFormsModule,
	ValidationErrors,
	Validator,
	Validators,
} from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { Email } from '../../models';
import { HtmlEditorComponent } from '../html-editor/html-editor.component';
import { InputComponent } from '../input/input.component';

@Component({
	selector: 'addiction-email',
	standalone: true,
	imports: [CommonModule, InputComponent, TranslateModule, HtmlEditorComponent, ReactiveFormsModule, MatTooltipModule],
	templateUrl: './email.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => EmailComponent),
			multi: true,
		},
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => EmailComponent),
			multi: true,
		},
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailComponent implements ControlValueAccessor, Validator {
	@Input() label: string = '';
	@Input() readonly: boolean = false;
	@Input() hint?: string;

	formGroup = new FormGroup({
		email: new FormControl<string | null>(null, [Validators.email]),
		emailSubject: new FormControl<string | null>(null),
		emailButtonText: new FormControl<string | null>(null),
		emailText: new FormControl<string | null>(null),
	});

	constructor() {}

	public onTouched: () => void = () => {};

	writeValue(value: Email): void {
		if (value && this.isValueEmail(value)) {
			this.formGroup.patchValue(value);
		}
	}

	registerOnChange(fn: any): void {
		this.formGroup.valueChanges.subscribe(fn);
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	setDisabledState(disabled: boolean) {
		if (disabled) {
			this.formGroup.disable({ emitEvent: false });
		} else {
			this.formGroup.enable({ emitEvent: false });
		}
	}

	validate(control: AbstractControl<any, any>): ValidationErrors | null {
		if (this.formGroup.invalid) {
			return { invalidForm: { valid: false, message: 'Email form fields are invalid' } };
		}
		return null;
	}

	registerOnValidatorChange(fn: () => void): void {
		this.formGroup.statusChanges.subscribe(fn);
	}

	/**
	 * Metodo per veriface se il valore che viene passato nel writeValue è effettivamente del tipo necessario per patchare la form
	 */
	private isValueEmail(obj: Email): boolean {
		return 'email' in obj && 'emailSubject' in obj && 'emailButtonText' in obj && 'emailText' in obj;
	}
}
